import { render, staticRenderFns } from "./ShippingIcon.vue?vue&type=template&id=895e64e2&scoped=true"
import script from "./ShippingIcon.vue?vue&type=script&lang=ts"
export * from "./ShippingIcon.vue?vue&type=script&lang=ts"
import style0 from "./ShippingIcon.vue?vue&type=style&index=0&id=895e64e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895e64e2",
  null
  
)

export default component.exports